import { RootPage, RootPageTransparentPaper } from "@app/components/RootPage";
import { RootPageHeader } from "@app/components/RootPageHeader";
import { useNavigate } from "react-router-dom";
import { rootPages, simulationPages } from "@app/const/route.const";
import { SimulationSingle } from "./SimulationSingle";
import { useEffect } from "react";
import { useUser } from "@app/pages/settings/useUser";
import { SimulationABTest } from "./SimulationABTest";
import { SimulationModels } from "./SimulationModels";
import { SimulationRun } from "./SimulationRun";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { PdfSimulationModelsModelsReport } from "./PdfSimulationModelsModelsReport/PdfSimulationModelsModelsReport";

const SimulationPageContent = () => (
  <RootPage sx={{ backgroundColor: "white" }}>
    <RootPageHeader
      isSmall
      title="Simulation"
      items={[
        {
          label: "Price - Driven",
          url: simulationPages.priceDrivenUrl,
          moduleSection: CarModuleSectionCode.SIMULATION_PRICE_DRIVEN,
        },
        {
          label: "Static",
          url: simulationPages.staticUrl,
          moduleSection: CarModuleSectionCode.SIMULATION_STATIC,
        },
        {
          label: "A/B Test",
          url: simulationPages.abTestUrl,
          moduleSection: CarModuleSectionCode.SIMULATION_AB_TEST,
        },
        {
          label: "Models",
          url: simulationPages.modelsUrl,
          moduleSection: CarModuleSectionCode.SIMULATION_MODELS,
        },
        {
          label: "Run",
          url: simulationPages.runUrl,
          moduleSection: CarModuleSectionCode.SIMULATION_ANALYSIS_RUN,
        },
      ]}
    />
    <RootPageTransparentPaper>
      <AccessRouteControl
        items={[
          {
            path: simulationPages.priceDrivenPath,
            element: <SimulationSingle isStatic={false} />,
            moduleSection: CarModuleSectionCode.SIMULATION_PRICE_DRIVEN,
          },
          {
            path: simulationPages.staticPath,
            element: <SimulationSingle isStatic={true} />,
            moduleSection: CarModuleSectionCode.SIMULATION_STATIC,
          },
          {
            path: simulationPages.abTestPath,
            element: <SimulationABTest />,
            moduleSection: CarModuleSectionCode.SIMULATION_AB_TEST,
          },
          {
            path: simulationPages.modelsPath,
            element: <SimulationModels />,
            moduleSection: CarModuleSectionCode.SIMULATION_MODELS,
          },
          {
            path: simulationPages.runPath,
            element: <SimulationRun />,
            moduleSection: CarModuleSectionCode.SIMULATION_ANALYSIS_RUN,
          },
          {
            path: simulationPages.pdfModelsModelsReportPath,
            element: <PdfSimulationModelsModelsReport />,
            moduleSection:
              CarModuleSectionCode.PDF_SIMULATION_MODELS_MODELS_REPORT,
          },
        ]}
        defaultPath={simulationPages.priceDrivenUrl}
      />
    </RootPageTransparentPaper>
  </RootPage>
);

export const SimulationPage = () => {
  const { isLoading, isCaravelUser } = useUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoading && !isCaravelUser) {
      navigate(rootPages.home);
    }
  }, [isCaravelUser, isLoading, navigate]);

  return (
    <AccessRouteControl
      items={[
        {
          path: simulationPages.pdfModelsModelsReportPath,
          element: <PdfSimulationModelsModelsReport />,
          moduleSection:
            CarModuleSectionCode.PDF_SIMULATION_MODELS_MODELS_REPORT,
        },
        {
          path: "*",
          element: <SimulationPageContent />,
        },
      ]}
      defaultPath={simulationPages.priceDrivenUrl}
    />
  );
};
